import { TagData } from 'chaika-frontend-types/frontend-cms';

import { List } from '@store/abstract/List';

interface FilterParams {
    name?: string;
}

export class TagList extends List<TagData, TagData, FilterParams> {
    protected create(params: TagData): TagData {
        return params;
    }

    protected filterValue(tag: TagData, filterParams: FilterParams): boolean {
        return this.filterFieldValueIncludesString(tag, filterParams.name, 'name');
    }
}
